let navigationRef;

export function setNavigate(ref) {
  navigationRef = ref;
}

export function navigate(name, params = {}) {
  navigationRef?.push(name, params);
}
